$(document).ready(function () {
  // Select all slides (both main and thumbnails)
  let slides = $(".desktop_gallery .product__media-item.slider__slide");
  let totalSlides = slides.length; // Correct total slide count

  // Hide navigation buttons if there are no images or only one image
  if (totalSlides <= 1) {
    $(".gallery-btn-left, .gallery-btn-right").hide();
  }

  console.log("Total Slides:" + totalSlides);

  /* desktop gallery control */

  $(".desktop_gallery .gallery-btn-right").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_gallery .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    console.log("desktop_mobile ... loading :" + totalSlides);

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let next = position + 1;

    console.log(next + " :" + totalSlides);
    // If we exceed the last slide, loop back to the first one (zero-based index)
    if (next >= totalSlides) {
      next = 0;
    }

    // Find the corresponding thumbnail and trigger click
    let nextThumbnail = $(".desktop_gallery .thumbnail-list__item")
      .eq(next)
      .find("button");

    if (nextThumbnail.length) {
      nextThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", next);
    }
  });

  $(".desktop_gallery .gallery-btn-left").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_gallery .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let prev = position - 1;

    // If we go before the first slide, loop back to the last one
    if (prev < 0) {
      prev = totalSlides - 1;
    }

    // Find the corresponding thumbnail and trigger click
    let prevThumbnail = $(" .desktop_gallery .thumbnail-list__item")
      .eq(prev)
      .find("button");

    if (prevThumbnail.length) {
      prevThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", prev);
    }
  });
});

//mobile gallery contorl

$(document).ready(function () {
  // Select all slides (both main and thumbnails)
  let slides = $(".desktop_mobile .product__media-item.slider__slide");
  let totalSlides = slides.length; // Correct total slide count

  console.log("desktop_mobile ... loading :" + totalSlides);

  // Hide navigation buttons if there are no images or only one image
  if (totalSlides <= 1) {
    $(".gallery-btn-left, .gallery-btn-right").hide();
  }

  console.log("Total Slides:", totalSlides);

  $(".desktop_mobile .gallery-btn-right").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_mobile .product__media-item.slider__slide");
    let totalSlides = slides.length; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let next = position + 1;

    console.log(next + " :" + totalSlides);
    // If we exceed the last slide, loop back to the first one (zero-based index)
    if (next >= totalSlides) {
      next = 0;
    }

    // Find the corresponding thumbnail and trigger click
    let nextThumbnail = $(".desktop_mobile .thumbnail-list__item")
      .eq(next)
      .find("button");

    if (nextThumbnail.length) {
      nextThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", next);
    }
  });

  $(".desktop_mobile .gallery-btn-left").click(function () {
    // Select all slides (both main and thumbnails)
    let slides = $(".desktop_mobile .product__media-item.slider__slide");
    let totalSlides = slides.length / 2; // Correct total slide count

    // Find the active slide
    let activeSlide = slides.filter(".is-active");

    // Get the current position (zero-based index)
    let position = slides.index(activeSlide);
    let prev = position - 1;

    // If we go before the first slide, loop back to the last one
    if (prev < 0) {
      prev = totalSlides - 1;
    }

    // Find the corresponding thumbnail and trigger click
    let prevThumbnail = $(" .desktop_mobile .thumbnail-list__item")
      .eq(prev)
      .find("button");

    if (prevThumbnail.length) {
      prevThumbnail.trigger("click");
    } else {
      console.warn("Thumbnail not found for position:", prev);
    }
  });
});

function updateTotalPrice() {
  // Get the base price from .price-item--regular (Detect currency from the text)
  let basePriceText = $(".price-item--regular").text().trim();
  let basePrice = parseFloat(basePriceText.replace(/[^0-9.]/g, "")) || 0;
  let currency = basePriceText.includes("USD") ? "USD" : "CAD"; // Detect currency

  // Get the extra charges from .bold_option_total span
  let extraPriceText = $(".bold_option_total span").text().trim();
  let extraPrice = parseFloat(extraPriceText.replace(/[^0-9.]/g, "")) || 0;

  if (extraPrice == "") {
    extraPrice = 0;
  }

  // Get the selected quantity
  let quantity = parseInt($("#qty-total").val()) || 1;

  // Calculate the total price
  let totalPrice = (basePrice + extraPrice) * quantity;

  // Update the total price in .total_amount with the detected currency
  $(".total_amount").text(`$${totalPrice.toFixed(2)} ${currency}`);

  if (totalPrice > 0) {
    // Update the total price in .total_amount with the detected currency
    $(".total_amount_header").text(`$${totalPrice.toFixed(2)} ${currency}`);
  }
}

// Function to handle the shape selection
function updateShapeSelection($shapeButton) {
  // Get the selected shape value
  var selectedShape = $shapeButton.data("shape");
  var selectedValue = $shapeButton.data("value");

  // Update the select dropdown value based on data-option_value_key
  $('select[name="properties[Shape]"]')
    .val(
      $(
        'select[name="properties[Shape]"] option[data-option_value_key="' +
          selectedValue +
          '"]'
      ).attr("value")
    )
    .trigger("change");

  // Update the display text for visual feedback
  $(".shape-text-display-shape").text($shapeButton.find(".shapeName").text());

  // Optional: Highlight the selected shape with an 'active' class
  $(".shape-button").removeClass("active"); // Remove active class from all shapes
  $shapeButton.addClass("active"); // Add active class to the selected shape

  var $variantSelect = $("#variant");

  console.log("selectedShape:" + selectedShape);
  if ("rectangle" == selectedShape) {
    console.log("rectangle");
    var $roundSizeSelect = $("select[name='properties[Rectangle Size]']");
    $variantSelect.attr("properties", "Rectangle Size");
  } else if ("oval" == selectedShape) {
    console.log("oval");
    var $roundSizeSelect = $("select[name='properties[Oval Size]']");
    $variantSelect.attr("properties", "Oval Size");
  } else if ("round" == selectedShape) {
    console.log("round");
    var $roundSizeSelect = $("select[name='properties[Round Size]']");
    $variantSelect.attr("properties", "Round Size");
  }

  $(
    'select[name="properties[Oval Size]"], ' +
      'select[name="properties[Rectangle Size]"], ' +
      'select[name="properties[Round Size]"]'
  ).val(""); // Reset values

  $(
    'select[name="properties[Oval Size]"], ' +
      'select[name="properties[Rectangle Size]"], ' +
      'select[name="properties[Round Size]"]'
  ).each(function () {
    var selectElement = this;
    selectElement.dispatchEvent(new Event("change", { bubbles: true })); // Dispatch change event
    selectElement.dispatchEvent(new Event("input", { bubbles: true })); // Dispatch input event
  });

  updateTotalPrice();

  // Remove all options from #variant select
  $variantSelect.empty();

  // Clone the options from Round Sizes and append them to #variant
  c = 0;
  $roundSizeSelect.find("option").each(function () {
    console.log("working");
    var value = $(this).attr("value");
    var text = $(this).text();
    var option = $("<option></option>")
      .attr("value", value)
      .text(text)
      .attr("key", c);
    $variantSelect.append(option);
    c++;
  });
}

$(document).ready(function () {
  //set view;

  $("#variant").empty();
  $(".color-selector-widget").hide();
  $(".real-form").hide();
  $(".size-guide-link-container").hide();
  // Initial update in case page loads with a quantity > 1
  updateTotalPrice();

  // Delegated event to handle click on any shape button
  $(".shape-container").on("click", ".shape-button", function (event) {
    // Prevent event bubbling to higher elements if needed
    event.stopPropagation();

    // Trigger the shape update event
    updateShapeSelection($(this));
  });

  $("#variant").change(function () {
    // Get the properties attribute (e.g., "Oval Sizes")
    var properties = $(this).attr("properties");

    // Get the selected key and adjust it to match `data-option_value_key`
    var key = $(this).find(":selected").attr("key") - 1;

    console.log("Properties: " + properties);
    console.log("Key: " + key);

    // Find the matching properties select and update its value
    var $targetSelect = $('select[name="properties[' + properties + ']"]');
    var targetValue = $targetSelect
      .find('option[data-option_value_key="' + key + '"]')
      .attr("value");

    if (targetValue !== undefined) {
      $targetSelect.val(targetValue);

      // Dispatch change and input events to ensure proper updates
      let selectElement = $targetSelect[0]; // Get the raw DOM element
      selectElement.dispatchEvent(new Event("change", { bubbles: true }));
      selectElement.dispatchEvent(new Event("input", { bubbles: true }));
    }

    updateTotalPrice();
  });

  // cart send off //

  $(".addCart_fake").on("click", function () {
    // Clear any previous error messages
    $("#errorMessage").empty();

    let missingFields = [];

    // Check if a variant is selected
    if ($("#variant").val() === "") {
      missingFields.push("Variant");
    }

    // Check if a shape is selected
    if ($(".shape-button.active").length === 0) {
      missingFields.push("Shape");
    }

    // If any fields are missing, show the error message and scroll to it
    if (missingFields.length > 0) {
      let errorMessage =
        "Please select the following before adding to cart: <br><ul>";
      missingFields.forEach((field) => {
        errorMessage += `<li>${field}</li>`;
      });
      errorMessage += "</ul>";

      $("#errorMessage").html(errorMessage);

      $("html, body").animate(
        {
          scrollTop: $("#errorMessage").offset().top - 20,
        },
        500
      );
    } else {
      console.log("All selections made. Adding to cart...");

      // Simulate clicking the real Add to Cart button

      var $quantityInput = $("#qty-total"); // The visible quantity field
      var $hiddenForm = $(".product-form form"); // Hidden SC Products form
      var $addToCartBtn = $(".addCart_fake"); // Fake Add to Cart button

      if (
        !$quantityInput.length ||
        !$hiddenForm.length ||
        !$addToCartBtn.length
      ) {
        console.error("One or more required elements not found.");
        return;
      }
      var quantityValue = $quantityInput.val();

      // Find or create the hidden quantity input inside the Shopify form
      var $hiddenQuantityInput = $hiddenForm.find("input[name='quantity']");
      if (!$hiddenQuantityInput.length) {
        $hiddenQuantityInput = $("<input>", {
          type: "",
          name: "quantity",
        }).appendTo($hiddenForm);
      }

      // Update the hidden quantity input value
      $hiddenQuantityInput.val(quantityValue);

      console.log("Submitting with quantity:", $hiddenQuantityInput.val()); // Debugging

      $(".product-form__submit.bold_hidden").trigger("click");
    }
  });

  $("#qty-total").on("input", function () {
    updateTotalPrice();
  });

  $("button.minus_qty").on("click", function () {
    console.log("Minus");
    let qtyInput = $("#qty-total");
    let currentValue = parseInt(qtyInput.attr("value")) || 1;

    // Decrease the value, but not below the min value
    if (currentValue > 1) {
      currentValue--; // Increment the value once
      qtyInput.val(currentValue);
      qtyInput.attr("value", currentValue);
      console.log("update price");
      updateTotalPrice();
    }
  });

  $("button.plus_qty").on("click", function () {
    let qtyInput = $("#qty-total");
    let currentValue = parseInt(qtyInput.attr("value")) || 1;
    currentValue++; // Increment the value once
    qtyInput.val(currentValue);
    qtyInput.attr("value", currentValue);
    console.log("update price");
    updateTotalPrice();
  });
});
